<template>
  <a-spin :spinning="bsspinning">
    <div class="u-container">
      <a-steps :current="current" class="u-step">
        <a-step v-for="item in steps" :key="item.title" :title="item.title">
          <a-icon slot="icon" :type="item.icon" />
        </a-step>
      </a-steps>
      <div class="steps-content">
        <!--选择协议-->
        <div v-if="current === 0">
          <div class="u-item">
            <label>项目名称：</label>
            <a-input class="u-input-item" v-model="projectInfo.projectName" placeholder="请选择项目"
              @click="selectProjectModal" />
            &nbsp;&nbsp;&nbsp;&nbsp;
            <a-input class="u-input-item" v-model="projectInfo.projectCode" placeholder="项目编码" disabled />
          </div>
          <div class="u-item">
            <label>项目协议：</label>
            <a-select class="u-input-item" v-model="currentProjectAgreementId" placeholder="请选择项目协议">
              <a-select-option v-for="item in allProjectAgreements" :key="item.value">{{ item.label }}</a-select-option>
            </a-select>
          </div>
        </div>
        <!--导入协议内容-->
        <div v-if="current === 1">
          <a-row :gutter="24" class="left">
            <a-col span="24">
              <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload" :multiple="false"
                :accept="'.xls,.xlsx'">
                <a-button type="default"> <a-icon type="upload" /> 选择文件 </a-button>
              </a-upload>
              <div style="position:absolute;float:left;top:-16px;left:150px;">
                <a-button type="primary" :disabled="fileList.length === 0" :loading="uploading" style="margin-top: 16px"
                  @click="handleUpload">
                  {{ uploading ? '上传中...' : '上传' }}
                </a-button>&nbsp;&nbsp;
                <a-button @click="handleDownloadTemplate">下载模板</a-button>
              </div>
            </a-col>
          </a-row>
          <a-row :gutter="22" style="margin-top: 15px;margin-left:1px;">
            <a-col span="6">
              <a-input placeholder="姓名/身份证/手机号" v-model="formSearch.keyword" />
            </a-col>
            <a-col span="10">
              <a-button type="primary" icon="search" :loading="uploading" :disabled="uploading"
                @click="searchData">查询</a-button>&nbsp;&nbsp;
              <a-button icon="redo" :loading="uploading" :disabled="uploading" @click="resetData">重置</a-button>
            </a-col>
          </a-row>
          <dynamic-table :key="'0'" :columns="importColumns" :table-data="importData" :is-full="true"
            :hide-row-selection="true" :max-height="500" :height="450" :hidePagination="true" />
        </div>
        <!--发起签署-->
        <div v-if="current === 2">
          <div style="padding:10px;">发送签署结果</div>
          <a-row :gutter="24">
            <a-col span="7">
              <a-input placeholder="姓名/身份证/手机号" v-model="formSearch1.keyword" />
            </a-col>
            <a-col span="7">
              <a-select placeholder="是否成功" v-model="formSearch1.isSuccess" style="width:95%;">
                <a-select-option value="0">失败</a-select-option>
                <a-select-option value="1">成功</a-select-option>
              </a-select>
            </a-col>
            <a-col span="8">
              <a-button type="primary" icon="search" :loading="uploading" :disabled="uploading"
                @click="searchData">查询</a-button>&nbsp;&nbsp;
              <a-button icon="redo" :loading="uploading" :disabled="uploading" @click="resetData">重置</a-button>
            </a-col>
          </a-row>
          <dynamic-table :key="'1'" :columns="resultColumns" :table-data="resultData" :is-full="true"
            :hide-row-selection="true" :max-height="500" :height="450" :hidePagination="true">
          </dynamic-table>
        </div>
      </div>
      <div class="steps-action">
        <a-button v-if="current > 0" style="margin-left: 8px" @click="prevStep">
          上一步
        </a-button>
        &nbsp;&nbsp;
        <a-button v-if="current < steps.length - 1" :loading="uploading" :disabled="uploading" type="primary"
          @click="nextStep">
          下一步
        </a-button>
        &nbsp;&nbsp;
        <a-button v-if="current == steps.length - 1" type="primary" @click="handleSendSignture" :loading="uploading"
          :disabled="uploading">
          发起签署
        </a-button>
        &nbsp;&nbsp;
        <a-button v-if="current == steps.length - 1" type="default" @click="handleClose">
          关闭
        </a-button>
      </div>
    </div>
  </a-spin>
</template>
<script>
import { CommonServiceProxy } from "@/shared/common-service";
import DynamicTable from './dynamictable.vue';
import { ModalComponentBase } from "@/shared/component-base";
import { ModalHelper } from "@/shared/helpers";
import SelectPageList from "@/components/linggong/select-page-list";
import axios from "axios";
import { AppConsts } from '@/abpPro/AppConsts';
import { fileDownloadService } from "@/shared/utils";
import checkAgeFunc from '@/components/PersonAgeTip/check.js';

export default {
  name: 'batchSendIndex',
  mixins: [ModalComponentBase],
  components: {
    DynamicTable
  },
  data () {
    return {
      bsspinning: false,
      current: 0,
      steps: [
        { title: '选择协议', icon: 'select' },
        { title: '导入协议内容', icon: 'import' },
        { title: '发起签署', icon: 'mail' }
      ],
      commonService: null,
      currentProjectAgreementId: undefined,
      projectInfo: {
        projectName: undefined,
        projectCode: '',
        projectId: null
      },
      allProjectAgreements: [],
      importColumns: [
      ],
      resultColumns: [
      ],
      formSearch: {
        keyword: ''
      },
      formSearch1: {
        keyword: '',
        isSuccess: undefined
      },
      importData: [],
      resultData: [],
      allImportData: [],
      allResultData: [],
      totalItems: 0,
      pageNumber: 1,
      request: {
        skipCount: 0,
        maxResultCount: 12
      },
      fileList: [],
      bsspinning: false,
      uploading: false
    }
  },
  methods: {
    nextStep () {
      if (this.current === 0) {
        if (!this.projectInfo.projectId || this.projectInfo.projectId === '') {
          abp.message.warn('请选择项目');
          return false;
        }
        if (!this.currentProjectAgreementId || this.currentProjectAgreementId === '') {
          abp.message.warn('请选择项目协议');
          return false;
        }
      } else if (this.current === 1) {
        if (!this.allImportData || this.allImportData.length <= 0) {
          abp.message.warn("请先上传协议内容");
          return false;
        }
      }
      this.current = this.current + 1;
    },
    prevStep () {
      this.current = this.current - 1;
    },
    selectProjectModal () {
      ModalHelper.create(
        SelectPageList,
        {
          selectType: "checkbox", // checkbox radio
          title: "选择项目", // 显示标题
          url: "/api/services/app/UnnaturalPersonProject/GetSelectPaged", // 数据接口URL
          searchPlaceholder: "项目名称/项目代码",
          columnsData: [
            {
              title: "项目名称",
              dataIndex: "name",
              key: "name",
            },
            {
              title: "项目代码",
              dataIndex: "description",
              key: "description",
            },
          ],
        },
        {
          isChange: true,
          width: "750px",
          heigth: "550px",
        }
      ).subscribe((res) => {
        const { success, data } = res;
        if (success) {
          if (data.length !== 1) {
            abp.message.warn("只能选择一个项目");
            return;
          }

          this.projectInfo.projectCode = data[0].description; //data.id;
          this.projectInfo.projectName = data[0].name; //data.name;
          this.projectInfo.projectId = data[0].id;
          this.getProjectAgreements();
        }
      });
    },
    getProjectAgreements () {
      this.commonService.get({
        url: '/api/services/app/UnnaturalPersonProjectAgreement/GetListByProjectId',
        params: {
          projectId: this.projectInfo.projectId,
          isInvalid: false
        }
      }).then(res => {
        this.allProjectAgreements.splice(0, this.allProjectAgreements.length);
        if (res && res.length > 0) {
          res.map(item => {
            this.allProjectAgreements.push({
              label: item.name,
              value: item.id,
              ...item
            })
            return null;
          });
        }
      });
    },
    // updatePageChange (newV) {
    //   let { page, pageSize } = newV;
    //   this.pageNumber = page;
    //   this.request.skipCount = (page - 1) * this.request.maxResultCount;
    //   let array = undefined;
    //   if (this.current == 2 && this.currentSearchData1.length > 0) {
    //     array = [...this.currentSearchData1];
    //   } else if(this.current == 1 && this.currentSearchData.length > 0) {
    //     array = [...this.currentSearchData];
    //   }

    //   this.searchData(array);
    // },
    // updateShowSizeChange (newV) {
    //   let { current, size } = newV;
    //   this.pageNumber = 1;
    //   this.request.maxResultCount = size;
    //   this.searchData();
    // },
    searchData () {
      this.bsspinning = true;
      try {
        let datas = [];
        if (this.current == 2) {
          datas = [...this.allResultData];
          this.resultData.splice(0, this.resultData.length);
        } else {
          datas = [...this.allImportData];
          this.importData.splice(0, this.importData.length);
        }
        if (datas && datas.length > 0) {
          if (this.current == 2) {
            if (this.formSearch1.keyword != '') {
              let keyword = this.formSearch1.keyword;
              datas = datas.filter(item => item.field1.indexOf(keyword) >= 0 || item.field3.indexOf(keyword) >= 0 || item.field2.indexOf(keyword) >= 0);
            }
            if (this.formSearch1.isSuccess == 0 || this.formSearch1.isSuccess == 1) {
              let success = this.formSearch1.isSuccess == 0 ? '失败' : '成功';
              let keyIndex = this.resultColumns.length - 1;
              let key = `field${keyIndex}`;
              datas = datas.filter(item => item[key] == success);
            }
          } else {
            if (this.formSearch.keyword != '') {
              let keyword = this.formSearch.keyword;
              datas = datas.filter(item => item.field1.indexOf(keyword) >= 0 || item.field3.indexOf(keyword) >= 0 || item.field2.indexOf(keyword) >= 0);
              datas = this.resetArray(datas);
            }
          }
          //const rows = datas.filter(item => item.index >= start && item.index < end);
          datas = this.resetArray(datas);
          datas.map(item => {
            if (this.current == 2) {
              this.resultData.push(item);
            } else {
              this.importData.push(item);
            }
            return null;
          });
        }
        console.warn('data', this.allResultData, this.allImportData);
      } catch (e) {
        console.error(e);
      } finally {
        this.bsspinning = false;
      }
    },
    resetData () {
      if (this.current == 2) {
        this.formSearch1.keyword = '';
        this.formSearch1.isSuccess = undefined;
      } else {
        this.formSearch.keyword = '';
      }
      this.searchData();
    },
    handleRemove (file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    handleUpload () {
      let url = AppConsts.remoteServiceBaseUrl + `/api/services/app/UPersonSign/ImportExcel?projectAgreementId=${this.currentProjectAgreementId}`;
      this.uploadFile(url, '导入成功');
    },
    uploadFile (url, message) {
      const { fileList } = this;
      if (!fileList || fileList.length !== 1) {
        abp.message.warn('未选择文件或文件数量大于1');
        return false;
      }
      const formData = new FormData();
      fileList.forEach(file => {
        formData.append('file', file);
      });
      this.uploading = true;
      const request = axios.create();

      let options = {
        method: "post",
        url: url,
        headers: {
          Accept: "application/x-www-form-urlencoded,multipart/form-data",
          Authorization: "Bearer " + abp.auth.getToken()
        },
        data: formData
      };
      request.request(options).then(res => {
        this.uploading = false;
        if (res.status === 200) {
          var result = res.data.result;
          if (result.success) {
            if (result.failedCount > 0) {
              abp.message.warn("操作成功，但是存在部分失败的数据，请留意");
            } else {
              abp.message.success(message);
            }
            const data = result.data
            console.warn(data);
            let index = 0;
            if (this.current === 2) {
              this.resultColumns = data[0].headers.map(item => {
                return {
                  show: true,
                  prop: item.key,
                  label: item.value
                };
              });
              this.allResultData.splice(0, this.allResultData.length);
              this.allResultData = data.map(item => {
                index++;
                let row = {};
                let i = 0;
                this.resultColumns.map(ic => {
                  row[ic.prop] = item.values[i];
                  i++;
                  return null;
                });
                return row;
              });
              this.resultColumns.unshift({ show: true, prop: 'index', label: '序号' });
            } else {
              this.importColumns = data[0].headers.map(item => {
                return {
                  show: true,
                  prop: item.key,
                  label: item.value
                };
              });
              this.allImportData.splice(0, this.allImportData.length);
              this.allImportData = data.map(item => {
                index++;
                let row = {};
                let i = 0;
                this.importColumns.map(ic => {
                  row[ic.prop] = item.values[i];
                  i++;
                  return null;
                });
                return row;
              });
              this.importColumns.unshift({ show: true, prop: 'index', label: '序号' });
            }
            this.searchData();
          } else {
            abp.message.error(result.message);
          }
        } else {
          abp.message.error(res.statusText);
        }
      }).catch(e => {
        this.uploading = false;
        abp.message.error('上传出错');
        console.error(e);
      });
    },
    beforeUpload (file) {
      let index = file.name.lastIndexOf('.');
      let fileExt = '';
      if (index >= 0) {
        fileExt = file.name.substring(index + 1).toLowerCase();
      }
      if (fileExt != 'xls' && fileExt != 'xlsx') {
        abp.message.warn('只能上传xls，xlsx文件');
        return false;
      }
      if (this.fileList.length >= 1) {
        abp.message.warn('只能选择一个文件');
        return false;
      }
      const isLt10M = file.size / 1024 / 1024 <= 10;
      if (!isLt10M) {
        this.$message.error("上传的文件必须小于 10MB！");
        return false;
      }
      this.fileList = [...this.fileList, file];
      return false;
    },
    handleDownloadTemplate () {
      this.commonService.get({
        url: '/api/services/app/UPersonSign/DownloadTemplate',
        params: {
          projectAgreementId: this.currentProjectAgreementId
        }
      }).then(res => {
        fileDownloadService.downloadTempFile(res);
      });
      // window.open('/fileTemplete/线下提报信息导入模板.xlsx');
    },
    async handleSendSignture () {
      this.spinning = true;
      try {
        const params = {
          projectAgreementId: this.currentProjectAgreementId,
          personnelIds: [],
          personInfos: this.allImportData.map(it => {
            return {
              realName: it.field1,
              phoneNumber: it.field2,
              idCard: it.field3
            }
          })
        };
        await checkAgeFunc(params, (res) => {
          if (res) {
            this.realSendToSign();
          }
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.spinning = false;
      }
    },
    realSendToSign () {
      abp.message.confirm('提示', '是否确认发送签署？', (res) => {
        if (res) {
          let url = AppConsts.remoteServiceBaseUrl + `/api/services/app/UPersonSign/ImportFormContent?ProjectId=${this.projectInfo.projectId}&ProjectAgreementId=${this.currentProjectAgreementId}`;
          this.uploadFile(url, '发送成功，请查看结果')
        }
      });
    },
    resetArray (array) {
      let index = 0;
      return array.map(item => {
        index++;
        item.index = index;
        return item;
      });
    },
    handleClose () {
      this.close();
    }
  },
  created () {
    this.commonService = new CommonServiceProxy(this.$apiUrl, this.$api);
  }
}
</script>
<style scoped>
.u-container {
  width: 100%;
  height: 100%;
  background-color: white;
  padding: 20px 0 15px;
}

.u-step {
  width: 95% !important;
  margin: 0 auto;
}

.steps-content {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 5px;
}

.u-input-item {
  width: 200px;
  margin: 0 5px;
}

.steps-action {
  margin-top: 24px;
  text-align: center;
}

.u-item {
  width: 99%;
  text-align: left;
  padding: 10px;
  margin-top: 10px;
}

.left {
  text-align: left;
  text-indent: 8px;
}

.ant-upload-list-item-card-actions {
  top: -1px !important;
}

.ant-upload-list-item-info {
  width: 80%;
}
</style>
